import "core-js/actual/disposable-stack"
import "core-js/actual/symbol/dispose"
import Cocooned from "@notus.sh/cocooned"

import { Stimulus, Controller } from "#/layouts/js/stimulus"

Stimulus.register("cocooned", class extends Controller {
  connect() {
    this.cocooned = Cocooned.create(this.element)
  }

  disconnect() {
    this.cocooned?.dispose()
  }
})
